var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.showDromoButton ? _c('div', {
    staticClass: "dromo-import-button chemtracker-module"
  }, [_c(_vm.buttonType, _vm._b({
    tag: "component",
    class: _vm.clearStyle,
    attrs: {
      "show-badge": false,
      "show-icon": false,
      "label": "Import",
      "id": "import-button"
    },
    on: {
      "click": _vm.startImport
    }
  }, 'component', _vm.$attrs, false), [!_vm.isGhostButton ? _c('img', {
    attrs: {
      "id": "dromo-import-help",
      "src": _vm.helpSrc,
      "alt": "help"
    }
  }) : [_c('img', {
    attrs: {
      "src": _vm.uploadSrc,
      "alt": "upload icon"
    }
  }), _vm._v("\n      Import\n    ")]], 2), _vm._v(" "), !_vm.isGhostButton ? _c('b-popover', {
    attrs: {
      "target": "dromo-import-help",
      "triggers": "hover focus"
    }
  }, [_c('template', {
    slot: "title"
  }, [_vm._v("CSV File Import")]), _vm._v("\n    Upload a CSV file to add new chemical container records and to edit\n    existing records (up to 10,000).\n  ")], 2) : _vm._e(), _vm._v(" "), _c('VNotificationsConfirmationModal', {
    attrs: {
      "title": "Container Import In Progress",
      "modal-id": "container-confirmation"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "v-modal-container"
  }, [_c('b-modal', {
    ref: "vmodal",
    attrs: {
      "centered": "",
      "hide-footer": "",
      "cancel-disabled": "",
      "ok-disabled": "",
      "no-close-on-backdrop": "",
      "hide-header": "",
      "id": "vmodal-dromo"
    }
  }, [_c('div', {
    staticClass: "v-modal-content"
  }, [_c('header', {
    staticClass: "v-modal-header"
  }, [_c('div', {
    staticClass: "header-title"
  }, [_c('h1', [_vm._v("Validation in progress, please wait.")])])]), _vm._v(" "), _c('div', {
    staticClass: "v-modal-busy"
  }, [_c('raft-busy', {
    attrs: {
      "busy-text": "It may take a few minutes to see results.",
      "is-raft-styling": false
    }
  })], 1)])])], 1)], 1) : _vm._e();

}
var staticRenderFns = []

export { render, staticRenderFns }